export const Roles = {
  CHILD: -1,
  ADMIN: 1,
  COORDINATOR: 2,
  CARRIER: 3,
  CLIENT: 4,
  DRIVER: 5
}

export const RoleNames = {
  [Roles.CARRIER]: 'carrier',
  [Roles.CLIENT]: 'client'
}

export default {
  Roles,
  RoleNames
}



// WEBPACK FOOTER //
// ./src/utils/user.js